import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
`

export const Row = styled.div`
  flex: 1;
  flex-direction: row;
  TextArea{
    resize: none;
  }
`

export const Padding = styled.div`
  padding: 0.5rem;

`
